/**
 * Preview-only route: same product grid + API as the shop, but uses
 * SliderMobNew with mobileCardVariant="simpleTouch" (SimpleTouchCarouselCard).
 * Touch/drag past tap slop on the image to activate; images advance one at a time
 * (compare with the default stacked crossfade cards on /products/...).
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useContextData } from '../../ApiContext';
import { SliderMobNew } from '../../Slider/SliderMobNew';
import './MobLtrCarouselPreviewPage.scss';

export function MobLtrCarouselPreviewPage() {
    const { queryParams, setQueryParams } = useContextData();
    const [queryParamsInit, setQueryParamsInit] = useState(false);

    useEffect(() => {
        setQueryParams({
            category: [],
            subcategory: [],
            price: [0, 10000],
        });
        setQueryParamsInit(true);
    }, [setQueryParams]);

    return (
        <div className="mob-ltr-preview">
            <header className="mob-ltr-preview__header">
                <Link to="/" className="mob-ltr-preview__back">
                    ← Home
                </Link>
                <h1 className="mob-ltr-preview__title">LTR-style carousel preview</h1>
                <p className="mob-ltr-preview__sub">
                    Uses <code>translateStrip</code>: all images sit in one horizontal row; the track shifts
                    left with <code>translateX</code> (same pattern as the old ProductSliderMulti strip). Main
                    shop uses <code>stacked</code> crossfade.{' '}
                    <strong>On this page only,</strong> click the image to start the carousel (for DevTools);
                    when active, click the image again to open PDP.
                </p>
            </header>
            <div className="mob-ltr-preview__grid-wrap">
                <SliderMobNew
                    url="/products"
                    queryParams={queryParams}
                    queryParamsInit={queryParamsInit}
                    mobileCardVariant="translateStrip"
                    mobPreviewClickActivatesCarousel
                />
            </div>
        </div>
    );
}
